import { standardDataAPI } from '@/utils/api'

const state = {
  departments: [],
  positions: [],
  leaveTypes: [],
  workShifts: [],
  documentProofTypes: [],
  loading: false,
  error: null
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_DEPARTMENTS(state, departments) {
    state.departments = departments
  },
  SET_POSITIONS(state, positions) {
    state.positions = positions
  },
  SET_LEAVE_TYPES(state, leaveTypes) {
    state.leaveTypes = leaveTypes
  },
  SET_WORK_SHIFTS(state, workShifts) {
    state.workShifts = workShifts
  },
  SET_DOCUMENT_PROOF_TYPES(state, documentProofTypes) {
    state.documentProofTypes = documentProofTypes
  }
}

const actions = {
  // Fetch departments
  async getDepartments({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      const response = await standardDataAPI.mobileGetDepartments()
      
      if (!response.didError) {
        commit('SET_DEPARTMENTS', response.model || [])
      }
      
      return response
    } catch (error) {
      console.error('Get departments error:', error)
      commit('SET_ERROR', error.message || 'Failed to fetch departments')
      return {
        didError: true,
        errorMessage: error.message || 'Failed to fetch departments'
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Fetch positions
  async getPositions({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      const response = await standardDataAPI.mobileGetPositions()
      
      if (!response.didError) {
        commit('SET_POSITIONS', response.model || [])
      }
      
      return response
    } catch (error) {
      console.error('Get positions error:', error)
      commit('SET_ERROR', error.message || 'Failed to fetch positions')
      return {
        didError: true,
        errorMessage: error.message || 'Failed to fetch positions'
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Fetch leave types
  async getLeaveTypes({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      const response = await standardDataAPI.mobileGetLeaveTypes()
      
      if (!response.didError) {
        commit('SET_LEAVE_TYPES', response.model || [])
      }
      
      return response
    } catch (error) {
      console.error('Get leave types error:', error)
      commit('SET_ERROR', error.message || 'Failed to fetch leave types')
      return {
        didError: true,
        errorMessage: error.message || 'Failed to fetch leave types'
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Fetch work shifts
  async getWorkShifts({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      const response = await standardDataAPI.mobileGetWorkShifts()
      
      if (!response.didError) {
        commit('SET_WORK_SHIFTS', response.model || [])
      }
      
      return response
    } catch (error) {
      console.error('Get work shifts error:', error)
      commit('SET_ERROR', error.message || 'Failed to fetch work shifts')
      return {
        didError: true,
        errorMessage: error.message || 'Failed to fetch work shifts'
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Fetch document proof types
  async getDocumentProofTypes({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      const response = await standardDataAPI.mobileGetDocumentProofTypes()
      
      if (!response.didError) {
        commit('SET_DOCUMENT_PROOF_TYPES', response.model || [])
      }
      
      return response
    } catch (error) {
      console.error('Get document proof types error:', error)
      commit('SET_ERROR', error.message || 'Failed to fetch document proof types')
      return {
        didError: true,
        errorMessage: error.message || 'Failed to fetch document proof types'
      }
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  departments: state => state.departments,
  positions: state => state.positions,
  leaveTypes: state => state.leaveTypes,
  workShifts: state => state.workShifts,
  documentProofTypes: state => state.documentProofTypes,
  
  // Filter document proof types by group
  documentProofTypesByGroup: (state) => (group) => {
    return state.documentProofTypes.filter(type => type.proofGroup === group)
  },
  
  // Get leave document proof types
  leaveDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'LEAVE')
  },
  
  // Get profile document proof types
  profileDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'PROFILE')
  },
  
  // Get agreement document proof types
  agreementDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'AGREEMENT')
  },
  
  // Get task document proof types
  taskDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'TASK')
  },
  
  // Get time attendance document proof types
  timeAttendanceDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'TIMEATTENDANT')
  },
  
  // Get evaluation document proof types
  evaluationDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'EVALUATE')
  },
  
  // Get request document proof types
  requestDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'REQUEST')
  },
  
  // Get resign document proof types
  resignDocumentProofTypes: (state) => {
    return state.documentProofTypes.filter(type => type.proofGroup === 'RESIGN')
  },
  
  loading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 